import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
const videoUrl = 'https://cdn.magicpatterns.com/uploads/gyvBbRyEvGMSpU1NUyMkb4/Alisado%20Progresivo%20Org%C3%A1nico%20%F0%9F%92%ABTurnitos%20disponibles%20para%20Agosto%20%F0%9F%92%98.mp4';
export function InstagramReel() {
  return <section className="w-full py-20 px-4 bg-white" data-id="element-76">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-12" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="w-full max-w-sm" data-id="element-78">
          <div className="relative aspect-[9/16] overflow-hidden rounded-3xl shadow-2xl shadow-pink/40 border-4 border-white" data-id="element-79">
            <video src={videoUrl} autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-80" />
            <div className="absolute top-4 left-4 bg-black/50 backdrop-blur-sm text-white px-3 py-1.5 rounded-full flex items-center gap-2 text-sm font-medium" data-id="element-81">
              <Instagram className="w-4 h-4" data-id="element-82" />
              Reels
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-md text-center md:text-left space-y-6" data-id="element-83">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal" data-id="element-84">
            Seguinos en Instagram
          </h2>
          <p className="text-lg text-charcoal/80" data-id="element-85">
            Descubrí más resultados increíbles, tips de cuidado y enterate de
            todas nuestras promociones antes que nadie.
          </p>
          <a href="https://instagram.com/vrbeautystudio.uy" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-white font-semibold rounded-full hover:opacity-90 transition-opacity shadow-lg" data-id="element-86">
            <Instagram className="w-5 h-5" data-id="element-87" />
            @vrbeautystudio.uy
          </a>
        </motion.div>
      </div>
    </section>;
}